import { render, staticRenderFns } from "./TitleSettings.vue?vue&type=template&id=0519e7c3&scoped=true"
import script from "./TitleSettings.vue?vue&type=script&lang=js"
export * from "./TitleSettings.vue?vue&type=script&lang=js"
import style0 from "./TitleSettings.vue?vue&type=style&index=0&id=0519e7c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0519e7c3",
  null
  
)

export default component.exports